import Cookies from "universal-cookie";
import { cookiesKeyNames } from "@revbox/common-fe";
import { getPubAbbr } from "@revbox/helpers-fe";
import { getPathKey, useCookiesContext } from "../../../../../contexts/CookiesContext";
import { brandingPPCAuctionsLabels, statusLabels } from "@revbox/localization";
import { TaxonomyModule } from "../../../../../modules/taxonomy";

export function StatusRenderer({ value }) {
  const { getLanguageAbbr } = useCookiesContext()
  if (!value) {
    return null;
  }
  const lang = getLanguageAbbr()
    const statusMap = {
      PENDING: "text-secondary fw-bold half-circle-indicator w-100",
      LIVE: "text-success fw-bold half-circle-indicator w-100",
      INACTIVE: "text-danger fw-bold half-circle-indicator w-100",
      PAUSED: "text-warning fw-bold half-circle-indicator w-100",
      INHERITED: "badge text-success w-100",
      "BID ACTIVE": "text-success fw-bold circle-indicator w-100",
    };

    let status = value.split("@")[0];
    const translatedStatus = Object.entries(statusLabels[lang]).find(([_key, value]) => value === status);

    let statusKey = status.toUpperCase();
    if (translatedStatus && translatedStatus[0]) {
      statusKey = translatedStatus[0].toUpperCase();
    } 
    let className = statusMap[statusKey];
    const statusEqualsInherited = status === statusLabels[lang]["Inherited"];
    // if (status === "LIVE") {
    //   status = "Bid Active".toUpperCase();
    // } 

    // if (views === 0) {
    //   status = "Inherited".toUpperCase();
    //   className = "badge bg-warning w-100";
    // }

    
    return className ? (
      <span className={className}>
        {statusEqualsInherited ? (
          <>
            <i className='ri-arrow-right-down-line'></i> {status.toUpperCase()}
          </>
        ) : (
          status.toUpperCase()
        )}
      </span>
    ) : (
      <span className="badge bg-secondary w-100">{statusLabels[lang]["Pending"].toUpperCase()}</span>
    );
}

export function StatusColumnHeaderTooltipRenderer() {
  const publisherIdByAbbr = getPubAbbr();
  const taxonomy = TaxonomyModule(publisherIdByAbbr);

  return taxonomy.tooltips.ppc_cluster_column_headers.status;
}

export function StatusCellTooltipRenderer({ value }) {
  const publisherIdByAbbr = getPubAbbr();
  const taxonomy = TaxonomyModule(publisherIdByAbbr);

  const cookies = new Cookies()
  const pathKey = getPathKey()
  const language = cookies.get(pathKey)?.[cookiesKeyNames.language]?.value || 'EN'

  const message = brandingPPCAuctionsLabels[language].yourStatus;  

  if (!value) {
    return null;
  }
  
  let status = value.split("@")[0]
  if (status === "Bid Active") {
    return taxonomy.tooltips.ppc_cluster_column_inlines.status.live;
  }

  if (status === "Inactive") {
    return taxonomy.tooltips.ppc_cluster_column_inlines.status.inactive;
  }

  if (status === "Paused") {
    return taxonomy.tooltips.ppc_cluster_column_inlines.status.paused;
  }

  if (status === "Pending") {
    return taxonomy.tooltips.ppc_cluster_column_inlines.status.pending;
  }

  if (status === "Inherited") {
    return taxonomy.tooltips.ppc_cluster_column_inlines.status.inherited;
  }

  return message + " " + status;
}

  